var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tg_white.svg",
    clipPath: "url(#clip0_1107_516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 0.403076C5.5982 0.403076 0.00317383 5.9981 0.00317383 12.9C0.00317383 19.8018 5.5982 25.3968 12.5 25.3968C19.4019 25.3968 24.9969 19.8018 24.9969 12.9C24.9969 5.9981 19.4019 0.403076 12.5 0.403076ZM18.2926 8.90196C18.1045 10.878 17.2907 15.6733 16.8766 17.8866C16.7014 18.8231 16.3564 19.1371 16.0226 19.1678C15.2969 19.2346 14.7458 18.6882 14.0429 18.2274C12.943 17.5065 12.3216 17.0576 11.2539 16.3541C10.0201 15.541 10.82 15.0943 11.5231 14.3636C11.7072 14.1725 14.9047 11.2641 14.9666 11.0003C14.9743 10.9673 14.9817 10.8441 14.9084 10.7794C14.8352 10.7147 14.7275 10.7366 14.6497 10.7542C14.5394 10.7792 12.7823 11.9406 9.3784 14.2383C8.87968 14.5807 8.42798 14.7476 8.02319 14.7389C7.57699 14.7292 6.71868 14.4866 6.08059 14.2791C5.29797 14.0248 4.67595 13.8903 4.73012 13.4582C4.75834 13.2331 5.06824 13.003 5.65982 12.7679C9.30291 11.1806 11.7322 10.1342 12.9477 9.62854C16.4182 8.185 17.1394 7.93426 17.6094 7.92589C17.7128 7.92418 17.9439 7.94978 18.0937 8.07127C18.1932 8.15779 18.2567 8.27858 18.2715 8.40969C18.2969 8.5725 18.3039 8.73759 18.2926 8.90196Z",
    fill: "#ab9788"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1107_516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9937,
    height: 25.8,
    fill: "white",
    transform: "translate(0.00317383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramGold);
export default __webpack_public_path__ + "static/media/telegram_gold.533b2f7abbad82a75c5feada016ef78e.svg";
export { ForwardRef as ReactComponent };